import {
  LABEL_FLAG,
  COMMON_QUESTION_PHRASE,
  COMMON_ANSWER_PHRASE,
  REQUIREMENTS_QUESTION,
  REQUIREMENTS_ANSWER,
  INCOME_QUESTION,
  INCOME_ANSWER,
  WORKPLACEENVIRONMENT_QUESTION,
  WORKPLACEENVIRONMENT_ANSWER,
  HOLIDAYANDWAYOFWORKING_QUESTION,
  HOLIDAYANDWAYOFWORKING_ANSWER,
  EMPLOYMENTSTATUS_QUESTION,
  EMPLOYMENTSTATUS_ANSWER,
} from '@doda/common/src/constants/seo/jobTrendConstants';
import { createRankingLabel } from '@doda/common/src/logics/JobContent/JobTrend/createLabel';

/**
 * 求人数が最も多いカテゴリごとの項目名を作成する（求人数が並ぶ場合、ひとりの文字列として返す）
 * @param {(string[] | number[])[]} rankingList 棒グラフ用配列(requirementsなどで指定したものを渡す)
 * @param {string} categoryFlg こだわりフラグ名
 * @returns 求人数が最も多いカテゴリごとの項目名
 */
export function createTopJobLabel(
  rankingList: (string[] | number[])[],
  categoryFlg: string
): string {
  let jobData = rankingList[0].map(Number);
  let jobLabel = rankingList[1].map(String);

  // 年収、設立、平均年齢をソートしなければならない
  if (
    categoryFlg === LABEL_FLAG.INCOME ||
    categoryFlg === LABEL_FLAG.ESTABLISH ||
    categoryFlg === LABEL_FLAG.EMPLOYEE_AVERAGE_AGE
  ) {
    const combinedArray = jobData.map((item, index) => [item, jobLabel[index]]);
    combinedArray.sort((a, b) => Number(b[0]) - Number(a[0]));
    jobData = combinedArray.map((item) => Number(item[0]));
    jobLabel = combinedArray.map((item) => String(item[1]));
  }

  const rankingCombinedArray = createRankingLabel(
    jobData,
    jobLabel,
    categoryFlg
  );
  const resultText = `${rankingCombinedArray[0][1]}`;

  return resultText;
}

/**
 * FAQの質問のフレーズを作成する
 * @param {string} targetName ページの一軸名
 * @param {string} categoryFlg こだわりフラグ名
 * @returns FAQの質問のフレーズ
 */
export function createQuestionQhrase(
  targetName: string,
  categoryFlg: string
): string {
  let qhrase = `「${targetName}」${COMMON_QUESTION_PHRASE}`;

  switch (categoryFlg) {
    case LABEL_FLAG.REQUIREMENT:
      qhrase += REQUIREMENTS_QUESTION;
      break;
    case LABEL_FLAG.INCOME:
      qhrase += INCOME_QUESTION;
      break;
    case LABEL_FLAG.WORKPLACE_ENVIRONMENT:
      qhrase += WORKPLACEENVIRONMENT_QUESTION;
      break;
    case LABEL_FLAG.HOLIDAY_AND_WAY_OF_WORKING:
      qhrase += HOLIDAYANDWAYOFWORKING_QUESTION;
      break;
    case LABEL_FLAG.EMPLOYMMENT_STATUS:
      qhrase += EMPLOYMENTSTATUS_QUESTION;
      break;
    default:
      break;
  }

  return qhrase;
}

/**
 * FAQの答えのフレーズを作成する
 * @param {string} jobLabel 整形されたカテゴリごとの項目名配列
 * @param {string} categoryFlg こだわりフラグ名
 * @returns FAQの答えのフレーズ
 */
export function createAnswerQhrase(
  jobLabel: string,
  categoryFlg: string
): string {
  let qhrase = `${COMMON_ANSWER_PHRASE}${jobLabel}`;

  switch (categoryFlg) {
    case LABEL_FLAG.REQUIREMENT:
      qhrase += REQUIREMENTS_ANSWER;
      break;
    case LABEL_FLAG.INCOME:
      qhrase += INCOME_ANSWER;
      break;
    case LABEL_FLAG.WORKPLACE_ENVIRONMENT:
      qhrase += WORKPLACEENVIRONMENT_ANSWER;
      break;
    case LABEL_FLAG.HOLIDAY_AND_WAY_OF_WORKING:
      qhrase += HOLIDAYANDWAYOFWORKING_ANSWER;
      break;
    case LABEL_FLAG.EMPLOYMMENT_STATUS:
      qhrase += EMPLOYMENTSTATUS_ANSWER;
      break;
    default:
      break;
  }

  return qhrase;
}
